import { validateUrl } from '@shared/util/validate/url';

export function addPrefixIfNeeded(input: string) {
  const prefixedInput = `https://${input.trim().replace(/^[/:]+/, '')}`;
  // add the https:// prefix if the current URL is invalid and adding the prefix
  // would make it valid
  if (!validateUrl(input) && validateUrl(prefixedInput)) {
    return prefixedInput.trim();
  } else {
    return input.trim();
  }
}
